var React = require('react');

function IconAccount2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.7778 2H4.22222C3 2 2 3 2 4.22222V19.7778C2 21 3 22 4.22222 22H19.7778C21 22 22 21 22 19.7778V4.22222C22 3 21 2 19.7778 2ZM12 5.33333C14.1444 5.33333 15.8889 7.07778 15.8889 9.22222C15.8889 11.3667 14.1444 13.1111 12 13.1111C9.85556 13.1111 8.11111 11.3667 8.11111 9.22222C8.11111 7.07778 9.85556 5.33333 12 5.33333ZM19.7778 19.7778H4.22222V19.5222C4.22222 18.8333 4.53333 18.1889 5.06667 17.7667C6.96667 16.2444 9.37778 15.3333 12 15.3333C14.6222 15.3333 17.0333 16.2444 18.9333 17.7667C19.4667 18.1889 19.7778 18.8444 19.7778 19.5222V19.7778Z","fill":"white"}));
}

IconAccount2.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconAccount2;

IconAccount2.default = IconAccount2;
